<script>
    export default {
        name: "VerticalDistanceElement",
        data() {
            return {
                elementType: "verticalDistance"
            }
        },
    }
</script>
